import { createRoutine } from 'redux-saga-routines';

import extendRoutine from 'utils/extendRoutines';

import { GET_SETTINGS_STORE, UPDATE_SETTINGS_STORE, GET_SETTING_CUSTOMIZE_PRINTS } from './constants';

export const getSettingsStore = extendRoutine(createRoutine(GET_SETTINGS_STORE), 'RESET');
export const updateSettingsStore = extendRoutine(createRoutine(UPDATE_SETTINGS_STORE), 'RESET');
export const getSettingsCustomizePrints = extendRoutine(createRoutine(GET_SETTING_CUSTOMIZE_PRINTS), 'RESET');
